import React, { useEffect, useState, useContext, useRef } from 'react';
import { formatWorkerType } from "../../util/FormattingService";
import { Typography, IconButton, Select, MenuItem, } from "@material-ui/core";
import { Colors, Spacing, AppContainerWidth } from "../../theme/Theme";
import { RBCardView } from "../../components/RBCardView";
import { RBButton } from "../../components/RBButton";
import { RoutePathConstant, RegistrationStatus } from "../../util/Common";
import { workerTypeEnum } from "../../util/Enumeration";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { AuthService } from "../../api/AuthService";
import { IndustryModeEnum } from '../../api/constants';
import { RBContext } from "../../components/RBContext";
import {
    useHistory,
    useLocation,
  } from "react-router-dom";
import { AccountInfoContext } from '../../components/AccountInfoContext';

export const RegisterationIncompletePage = ({ ...props}) => {
    console.log(props)

    const { accountInformation } = useContext(AccountInfoContext);
    const history = useHistory();
    const location = useLocation<{
        userData: any;
      }>();
      const { primaryColor,secondaryColor, industryMode,contactEmail,contactPhone ,updateprimaryColor,updateSecondaryColor,updateContactEmail,updateContactPhone,updateMode } = useContext(RBContext);
      const [loading, setIsloading] = useState(false);
      const hasOpenedForm = useRef(false);
      
    useEffect(() => {
        (async () => {
            await updateprimaryColor( localStorage.getItem('primaryColor')); 
            await updateSecondaryColor( localStorage.getItem('secondaryColor')); 
            await updateContactEmail( localStorage.getItem('contactEmail')); 
            await updateContactPhone( localStorage.getItem('contactPhone')); 
            await updateMode(localStorage.getItem('industryMode')); 
        })();
    }, []);

    // accountInformation is loaded asynchronously by AccountInfoContext and is null
    // on the first render, so route once it is actually available.
    useEffect(() => {
        // Open the form once. accountInformation is refreshed when registration is
        // submitted, and re-opening it then would cover the pending-approval redirect.
        if (!accountInformation || hasOpenedForm.current) {
            return;
        }
        if (accountInformation.registrationStatus !== RegistrationStatus.PreRegistered) {
            return;
        }
        hasOpenedForm.current = true;
        loadForm()
    }, [accountInformation]);

    const loadForm = async () => {
        if (accountInformation.roleName === 'owner') {
            history.push(RoutePathConstant.RegisterOwnAndPharmacy, {
                background: location,
                ownerType: accountInformation.roleOpted,
                industryMode: accountInformation?.healthcareProfession,
                account:accountInformation
            })
        }
        else {
            history.push(
                `${RoutePathConstant.RegisterWorker}${accountInformation.roleOpted}`,
                {
                    background: location,
                    workerType: accountInformation.roleOpted,
                    industryMode: accountInformation?.healthcareProfession,
                    account:accountInformation
                }
            )
        }
    }
    return null

    // return (
    //     <RBCardView
    //     style={{
    //         padding: Spacing.large,

    //         marginTop: "10%",
    //         width: AppContainerWidth,

    //         display: "flex",
    //         flex: 1,
    //         height: "100%",
    //         maxWidth: "100%",
    //         flexDirection: "column",
    //         alignItems: "flex-start",
    //     }}
    // >
    //     <div
    //         style={{
    //             width: "100%",
    //             paddingBottom: 10
    //         }}
    //     > 
    //     </div>
    //         <Typography
    //             variant={"h6"}
    //             style={{ textAlign: "center" }}
    //         >
    //            Complete the Regitration process.
    //         </Typography>
           
    //     <Typography>
    //         <div
    //             style={{
    //                 display: "flex",
    //                 marginTop: 2 * Spacing.larger,
    //                 marginBottom: Spacing.larger,
    //                 paddingLeft: 8 * Spacing.larger,
    //                 paddingRight: 8 * Spacing.large,
    //             }}
    //         >
    //             <RBButton
    //                 style={{
    //                     width: 594,
    //                     paddingLeft: Spacing.large,
    //                     paddingRight: Spacing.large,
    //                     paddingTop: Spacing.medium,
    //                     paddingBottom: Spacing.medium,
    //                 }}
    //                 buttonBackgroundColor={primaryColor}
    //                 text="Logout"
    //                 isLoading={isSubmitting}
    //                 variant="contained"
    //                 type="submit"
    //                 onClick={() => {
    //                     AuthService.removeAuth();
    //                     history.push(RoutePathConstant.SignIn);
    //                 }}
    //             />
    //         </div>
    //     </Typography>

    // </RBCardView>
    // );
};
